import {Component, ComponentRef, Injector, Input, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {DialogBaseComponent} from "../../base-admin-panel/dialog-base/dialog-base.component";
import { KeySyncModel, KeySyncViewModel} from "../Model/KeyViewModel";
import {ObjectsService} from "../../../../services/objects.service";
import { GroupFilterModel } from "../../../shared/pipes/FilterByNameAndGroup.pipe";
import {ObjectsManagementDialogComponent} from "../../objects-management-dialog/objects-management-dialog.component";
import {DialogService} from "../../../../services/dialog.service";
import {KeysService} from "../../../../services/keys.service";
import {EditKeyComponent} from "../edit-key.coponent";

@Component({
    selector: 'app-objectkeys-sync-dialog',
    templateUrl: './objectkeys-sync-dialog.component.html',
    styleUrls: ['./objectkeys-sync-dialog.component.css'],
    standalone: false
})
export class ObjectKeysSyncDialogComponent extends DialogBaseComponent<KeySyncViewModel> implements OnInit {
  @ViewChild("objectsListDialog", { read: ViewContainerRef, static: true }) objectsListContainer;
  private objectsListDialog: ComponentRef<any>;
  @ViewChild("mgmtDialog", { read: ViewContainerRef, static: true }) container;
  protected componentRef: ComponentRef<any>;

  private objectsService: ObjectsService;
  private dialogService: DialogService;
  private keysService: KeysService;

  public keys: KeySyncViewModel[] = [];
  public filter: GroupFilterModel = new GroupFilterModel();
  public nameFilter: string;
  public forceRemove: KeySyncViewModel[] = [];

  public objectId: number;
  @Input('objectId')
  set onObjectIdSet(id) {
    this.objectId = id;
    this.Refresh();
  }

  private Refresh() {
    this.objectsService.GetSyncKeysForObject(this.objectId).subscribe(keys => { this.keys = keys; })
  }

  constructor(protected injector: Injector) {
    super(injector);
    this.dialogId = "syncKeys";
    this.objectsService = injector.get(ObjectsService);
    this.keysService = injector.get(KeysService);
    this.dialogService = injector.get(DialogService);
  }

  public selectKeys() {
    this.objectsListDialog = this.dialogService.open(this.objectsListContainer, ObjectsManagementDialogComponent);
    this.objectsListDialog.instance.onOpen.subscribe(() => {
      //keys not in the sync table
      this.keysService.GetKeys().subscribe(keys => {
        this.objectsListDialog.instance.objects = keys.filter(k => this.keys.map(ks => ks.KeyId).indexOf(k.Id) < 0);
      })
    });
    this.objectsListDialog.instance.onSubmit.subscribe(() => {

      this.objectsListDialog.instance.objects.forEach(key => {
        if (key && key.IsChecked) {
          let model = new KeySyncViewModel();
          model.ObjectId = this.objectId;
          model.KeyId = key.Id;
          model.Id = model.KeyId;
          model.KeyName = key.Name;
          model.Name = key.Name;
          model.NeedAdd = true;
          this.keys.push(model)
        }
      });
      this.objectsListDialog.instance.close();
    });
    this.objectsListDialog.instance.onClose.subscribe(() => {
    });
    this.objectsListDialog.instance.open();
  }

  public onTermChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.filter.term = input.value;
  }

  ngOnInit() {
    this.Refresh();
  }

  resyncKeys() {
    let model = this.keys.filter(k => k.IsChecked == true && k.NeedDelete == false)
                        .map(k => k);

    this.keysService.ResyncKeys(model)
      .subscribe(() => {
          this.Refresh();
        });
  }

  openEditKeyDialog(key: KeySyncViewModel) {
    this.componentRef = this.dialogService.open(this.container, EditKeyComponent);
    this.componentRef.instance.onSubmit.subscribe(() =>
    {
      let updatedKey = this.componentRef.instance.model;
      let keySyncModel = this.keys.find(k => k.Id == updatedKey.Id);
      if (keySyncModel)
      {
        keySyncModel.Name = updatedKey.Name;
        keySyncModel.KeyName = updatedKey.Name;
      }
    });

    this.componentRef.instance.show(key.KeyId);
  }


  public onToggleAll(value: boolean) {
    this.keys.forEach((command) => {
      command.IsChecked = value;
    });
    this.selectObjectsCount = this.keys.filter(c => c.IsChecked).length;
  }


  public onToggle(val: any) {
    this.selectObjectsCount = this.keys.filter(c => c.IsChecked).length;
  }

  deleteKeyFromSync(key: KeySyncViewModel) {
    if (key.NeedDelete == true) {
      let message = this.translate.instant("Do you really want to forcibly remove the key ");
      if (!confirm(message + key.Name + "?")) return;
      this.forceRemove.push(key);
      let idx = this.keys.indexOf(key);
      this.keys.splice(idx, 1);
    } else {
      key.NeedDelete = true;
    }
  }

  deleteSelected() {
    for (let key of this.keys.filter(k => k.IsChecked)) {
      key.NeedDelete = true;
      key.IsChecked = false;
    }
  }
  public submit() {

    if (this.forceRemove.length > 0)
    {
      let arr: KeySyncModel[] = [];

      for (let i = 0; i < this.forceRemove.length; i++)
      {
        let m = new KeySyncModel();
        m.KeyId = this.forceRemove[i].KeyId;
        m.ObjectId = this.forceRemove[i].ObjectId;
        arr.push(m);
      }
      this.keysService.ForceUnsyncKeys(arr).subscribe(() => { })
    }


    this.objectsService.SetSyncKeysForObject(this.objectId, this.keys.filter(k => !k.NeedDelete).map(k => k.KeyId))
      .subscribe(() => { });

    super.submit();
  }
}
